import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { fontSize, wh } from '../../mixins'
import { selectEventsData } from '../events/eventsSlice'
import UIButton from '../../UI/UIButton'
import MainHeadline from '../../UI/MainHeadline';
import MainDescription from '../../UI/MainDescription';


const isArabic = navigator.language.startsWith('ar');
const textAlign = isArabic ? 'right' : 'left';

export const ListWrapper = styled.div`
    position: relative;
    flex-grow: 1;
    max-height: 380px;
    overflow: hidden;
    margin-top: 30px;
`;

export const StyledList = styled.ul`
    list-style: none;
    position: absolute;
    ${wh('100%')};
    overflow-y: scroll;
	-webkit-overflow-scrolling:touch;
`;

export const StyledItem = styled.li`
    width: 100%;
    height: 56px;
    padding: 18px 16px;
    background-color: ${({active}) => active ? '#FFE5D2' : '#F2F2F2'};
    transition: background-color 300ms;
    border-radius: 12px;
    display: flex;
    flex-direction: ${isArabic ? 'row-reverse' : 'row'};
    justify-content: flex-start;
    align-items: center;
    color: #323232;
    ${fontSize(16)};
    line-height: 20px;
    position: relative;
    cursor: pointer;
    
    &:not(:last-child) {
        margin-bottom: 8px;
    }
    
    &:after {
        content: '';
        display: block;
        ${wh('20px')};
        position: absolute;
        top: 50%;
        right: 16px;
        left: 16px;
        ${textAlign}: auto;
        margin-top: -12px;
        background: url('../assets/checkmark-circle.svg') center / cover no-repeat;
        opacity: ${({active}) => active ? 1 : 0};
        transition: opacity 300ms;
    }
`;

const ChooseOptionContainer = ({ title, description, pageEvent, onContinueClick, buttons }) => {
    const {t} = useTranslation();
    const eventsData = useSelector(selectEventsData);
    const [initEventSent, setInitEventStatus] = useState(false);
    const [chosenOption, setChosenOption] = useState(null);

    const renderItem = (i, index) => {
        return (
            <StyledItem key={index}
                        onClick={() => setChosenOption(i)}
                        active={i === chosenOption}
                        id={'option-'+(index+1)}
            >
                <span>{t(i)}</span>
            </StyledItem>
        )
    };

    useEffect(() => {
        if (initEventSent) return;
        sendAnalyticsEvents(EVENTS[pageEvent], eventsData);
        setInitEventStatus(true)
    }, [eventsData, initEventSent, pageEvent]);

    return (
        <>
            <MainHeadline>{t(title)}</MainHeadline>
            <MainDescription>{t(description)}</MainDescription>
            <ListWrapper>
                <StyledList>{buttons.map(renderItem)}</StyledList>
            </ListWrapper>
            <UIButton onClick={() => onContinueClick(chosenOption)} disabled={!chosenOption} customMargin={'16px 0 0'} />
        </>
    )
};

export default ChooseOptionContainer